import { Box } from "@outschool/backpack";
import {
  LeaderFragmentFragment,
  PublicReviewFragmentFragment,
} from "@outschool/gql-frontend-generated";
import { useMachineTranslation } from "@outschool/localization";
import { leaderPath } from "@outschool/routes";
import React from "react";

import { ReviewHeader } from "./ReviewHeader";

type TeacherResponseProps = {
  // @ts-ignore TS(2339): Property 'leader' does not exist on type '{ __type... Remove this comment to see the full error message
  teacher: PublicReviewFragmentFragment["activity"]["leader"];
  review: PublicReviewFragmentFragment;
};

export const TeacherResponse: React.FunctionComponent<TeacherResponseProps> = ({
  teacher,
  review,
}) => {
  const { translate } = useMachineTranslation();
  return (
    <Box
      sx={{
        marginLeft: "0.5em",
        borderLeft: "1px solid",
        paddingLeft: "0.5em",
        borderColor: "grey.100",
      }}
    >
      <ReviewHeader
        user={teacher as LeaderFragmentFragment}
        userName={teacher.name}
        userLink={leaderPath(teacher.uid, teacher.leader_link)}
        responseTime={review.teacher_responded_at}
      />
      {/* @ts-ignore TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message */}
      {translate(review.teacher_response)}
    </Box>
  );
};
